import React from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { get } from 'global/lib/lodash';
import { ListItemText, ListItemIcon, ListItemButton } from '@mui/material';
import ReportsIcon from '@mui/icons-material/Assignment';
import Tooltip from '@mui/material/Tooltip';
import ReportsLockIcon from '@mui/icons-material/Lock';
import LotIcon from '@mui/icons-material/Home';
import { uppercaseFirst } from 'global/utils';
import TypoLabel from 'global/components/typo-label';
import { Loading } from 'global/styles';
import { CommunityIcon, DivisionIcon } from 'global/components/PerformIcons';
import ScoreIcon from 'global/components/ScoreIcon';
import { RlIcon, HideXSmall, DisplayScores, RlScore } from './ReportList.styles';
import { getRealmName } from 'global/utils';

const Location = ({ realm, realmType }) => {
  return (
    <>
      {realmType === 'lot' ? (
        <RlIcon as={LotIcon} />
      ) : realmType === 'community' ? (
        <RlIcon as={CommunityIcon} />
      ) : realmType === 'division' ? (
        <RlIcon as={DivisionIcon} />
      ) : (
        <RlIcon as={ReportsIcon} />
      )}
      {uppercaseFirst(realm)}
    </>
  );
};

// eslint-disable-next-line import/no-anonymous-default-export
export default (props) => {
  const { item } = props;
  const content = {
    ...item,
    title: get(item, 'name', Loading),
    realm: getRealmName(item),
    realmType: get(item, 'realm.tier', Loading),
    startDate: get(item, 'startDate', Loading),
    auditor: get(item, 'authors.0.email', '-unknown-'),
    scores: get(item, 'scores', Loading),
    status: get(item, 'status', Loading),
  };

  const getScoreNode = () => {
    if (content.status === 'draft') {
      return 'Draft';
    } else if (content.status === 'review') {
      return 'Under Review';
    } else {
      return <ScoreDisplay scores={content.scores ? content.scores : {}} id={content.id} />;
    }
  };

  return (
    <>
      <Tooltip title={get(item, 'locked') ? 'Locked by: ' + get(item, 'lockedBy.0.name') : ''} placement="right">
        <ListItemButton component={Link} to={`/reports/assessment/${content.id}`} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <HideXSmall as={ListItemIcon}>{get(item, 'locked') ? <ReportsLockIcon /> : <ReportsIcon />}</HideXSmall>
          <ListItemText
            sx={{ flex: 1, minWidth: 0 }}
            primary={content.title}
            slotProps={{ secondary: { component: 'div' } }}
            secondary={
              <>
                <TypoLabel hideSmallPrimary="true" primary={'Location: '} secondary={<Location realm={content.realm} realmType={content.realmType} />} />
                <TypoLabel hideSmallPrimary="true" primary={'Started: '} secondary={moment(content.startDate).format('MM/DD/YYYY')} />
                <TypoLabel hideSmallPrimary="true" primary={'Author: '} secondary={content.auditor} />
              </>
            }
          />
          <DisplayScores sx={{ flexShrink: 0, alignSelf: 'center' }}>
            {getScoreNode()}
          </DisplayScores>
        </ListItemButton>
      </Tooltip>
    </>
  );
};

const ScoreDisplay = ({ scores, id }) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
      {Object.keys(scores).map((scorecardId) => {
        const score = scores[scorecardId].calculatedScore;
        return (
          <RlScore key={scorecardId}>
            <HideXSmall>Score:&nbsp;</HideXSmall>
            {`${scores[scorecardId].displayValue}`}
            <ScoreIcon score={score} />
          </RlScore>
        );
      })}
    </div>
  );
};
